import { NumberInput } from '@mantine/core';
import { AddEditMatterFormData, Form } from '../types';
import styles from '../sharedStyles/InputField.module.css';
import { getInputPropsSafe, Paths } from '@/utils/getInputPropsSafe';

const PercentInput = ({
  form,
  label,
  name,
  id,
  labelProps,
}: {
  form: Form;
  label: string;
  name: Paths<AddEditMatterFormData>;
  id?: string;
  labelProps?: React.ComponentProps<typeof NumberInput>['labelProps'];
}) => {
  return (
    <NumberInput
      suffix='%'
      className={styles.inputField}
      {...getInputPropsSafe(form, name)}
      id={id ?? name}
      label={label}
      labelProps={labelProps}
      min={0}
      max={100}
      allowNegative={true}
    />
  );
};

export default PercentInput;
